module.exports = __webpack_public_path__ + "img/BackgroundRemoval05.b59fe902.png";